import React from "react";

import "./ErrorBoundary.css";

interface ErrorBoundaryProps {
	children: React.ReactNode;
}

interface ErrorBoundaryState {
	error: unknown | null;
}

export class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	state: ErrorBoundaryState = { error: null };

	static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
		return { error };
	}

	render(): React.ReactNode {
		const { error } = this.state;
		return error === null ? (
			this.props.children
		) : (
			<div className="error-boundary">{`${error}`}</div>
		);
	}
}
